import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckDouble } from '@fortawesome/free-solid-svg-icons'

export default function SkillCategory({ category }) {
    return (
        <div className='skills__content'>
            <h3 className='skill__title'>{category.title}</h3>
            <div className='skill__box'>
                <div className='skill__group'>
                    {category.skills.slice(0, Math.ceil(category.skills.length / 2)).map((skill, index) => (
                        <div className='skill__data' key={index}>
                            <FontAwesomeIcon icon={faCheckDouble} className='badge' />
                            <div>
                                <h3 className='skills__name'>{skill.name}</h3>
                                <span className='skills__level'>{skill.level}</span>
                            </div>
                        </div>
                    ))}
                </div>

                <div className='skill__group'>
                    {category.skills.slice(Math.ceil(category.skills.length / 2)).map((skill, index) => (
                        <div className='skill__data' key={index + Math.ceil(category.skills.length / 2)}>
                            <FontAwesomeIcon icon={faCheckDouble} className='badge' />
                            <div>
                                <h3 className='skills__name'>{skill.name}</h3>
                                <span className='skills__level'>{skill.level}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
